import { Box, Button, Flex, Link } from "@chakra-ui/react";
import { NavLink } from "react-router-dom";

import useNamespace from "~/hooks/useNamespace";

interface Props {
  isMobileDevice: boolean;
  productName: string;
  navigate: (to: string) => void;
  search: string;
  externalLink?: string | null;
  fioDomain: string;
}

function Footer({ isMobileDevice, productName, navigate, search, externalLink, fioDomain }: Props) {
  const { translate } = useNamespace("signIn");
  const isTalks = productName.toLowerCase() === "talks";

  return (
    <>
      {isTalks && !isMobileDevice && (
        <Button
          mt="-4"
          as={Link}
          onClick={() => (window.location.href = `https://talks${fioDomain}/auth/login/teacher`)}
          variant="terciary"
          color="gray.600"
        >
          {translate("signIn@talks-teacher-link")}
        </Button>
      )}
      {isMobileDevice &&
        (externalLink ? (
          <Button
            as={Link}
            onClick={() => navigate(externalLink)}
            variant="terciary"
            color="white"
            borderRadius="100px"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            paddingX="30px"
            paddingY="10px"
            gap="8px"
            textDecoration="none"
            _hover={{
              textDecoration: "none",
            }}
            className="flex items-center justify-between border-2"
          >
            <div className="flex items-center justify-between gap-1">
              <Box textStyle="label.primary" color="white">
                {translate("signIn@not-student-yet")}
              </Box>
              <Box color="white" textDecoration="underline">
                {translate("signIn@como-to-fluency")}
              </Box>
            </div>

            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H15"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path d="M10 17L15 12L10 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M15 12H3" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Button>
        ) : (
          <Flex direction="column" alignItems="center" width="inherit" my={["4", "auto"]}>
            <Flex direction="row" alignItems="center" gridColumnGap="1">
              <Box textStyle="label.primary" color="gray.600">
                {translate("signIn@without-account")}
              </Box>
              <Button as={NavLink} to={`/signup/${search}`} variant="terciary">
                {translate("signIn@signup-link")}
              </Button>
            </Flex>
            {isTalks && (
              <Button
                as={Link}
                onClick={() => (window.location.href = `https://talks${fioDomain}/auth/login/teacher`)}
                variant="terciary"
                color="gray.600"
              >
                {translate("signIn@talks-teacher-link")}
              </Button>
            )}
          </Flex>
        ))}
      {!isMobileDevice && (
        <Button
          as={Link}
          onClick={() => {
            if (externalLink) navigate(externalLink);
            else navigate(`/signup/${search}`);
          }}
          variant="terciary"
          color="white"
          borderRadius="100px"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          paddingX="30px"
          paddingY="10px"
          gap="8px"
          textDecoration="none"
          _hover={{
            textDecoration: "none",
          }}
          className="flex items-center justify-between border-2"
        >
          <div className="flex items-center justify-between gap-1">
            <Box textStyle="label.primary" color="white">
              {translate("signIn@not-student-yet")}
            </Box>
            <Box color="white" textDecoration="underline">
              {translate("signIn@como-to-fluency")}
            </Box>
          </div>

          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H15"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path d="M10 17L15 12L10 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15 12H3" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </Button>
      )}
    </>
  );
}

export default Footer;
